// Shared estimate math for detailed RAG waiting UI.
// Duration/weights come from the server; this only maps elapsed time → stage / %.

export function normalizeStage(raw) {
  if (raw == null) return { title: "", detail: "", weight: 1 }
  if (typeof raw === "string") return { title: raw, detail: "", weight: 1 }

  const weight = Number(raw.weight)
  return {
    title: String(raw.title || ""),
    detail: String(raw.detail || ""),
    weight: Number.isFinite(weight) && weight > 0 ? weight : 1
  }
}

export function stageTimings(stages, durationMs) {
  const normalized = stages.map(normalizeStage)
  const totalWeight = normalized.reduce((sum, stage) => sum + stage.weight, 0) || 1
  let acc = 0

  return normalized.map((stage) => {
    const startMs = (acc / totalWeight) * durationMs
    acc += stage.weight
    return { ...stage, startMs, endMs: (acc / totalWeight) * durationMs }
  })
}

export function stageIndexAt(elapsedMs, timings) {
  if (!timings.length) return 0

  for (let i = 0; i < timings.length; i += 1) {
    if (elapsedMs < timings[i].endMs) return i
  }

  return timings.length - 1
}

// Linear through the expected window up to 90% of maxPercent, then a slow
// creep toward maxPercent so a long tail never looks "stuck at 99%".
export function progressPercentAt(elapsedMs, durationMs, maxPercent) {
  const elapsed = Math.max(0, elapsedMs)
  const duration = Math.max(1, durationMs)
  const cap = maxPercent * 0.9

  if (elapsed >= duration) {
    const extra = (elapsed - duration) / duration
    return Math.min(maxPercent, cap + (maxPercent - cap) * (1 - Math.exp(-1.2 * extra)))
  }

  return cap * (elapsed / duration)
}

export function percentForStageIndex(index, stages, maxPercent) {
  if (index < 0) return 0

  const normalized = stages.map(normalizeStage)
  const totalWeight = normalized.reduce((sum, stage) => sum + stage.weight, 0) || 1
  const done = normalized.slice(0, index + 1).reduce((sum, stage) => sum + stage.weight, 0)
  return Math.min(maxPercent - 1, (done / totalWeight) * maxPercent)
}

export function remainingMinutes(elapsedMs, durationMs) {
  return Math.ceil(Math.max(0, durationMs - elapsedMs) / 60000)
}

export function formatEta(elapsedMs, durationMs, templates) {
  const minutes = remainingMinutes(elapsedMs, durationMs)
  if (minutes <= 0) return templates.wrapping_up || ""

  const pattern = templates.minutes || ""
  return pattern.replace("{n}", String(minutes))
}
